const removeNonBreakingSpace = (str) => {
  return str.replace(/(?=\s)[^\r\n\t]/g, ' ')
}

export default removeNonBreakingSpace;
